import * as React from 'react';
import UserForm from '@magoosh/organisms/signup_form';
import fetch from "utilities/fetch";
import {paths} from "config/path_helpers";
import {SubmissionError} from "redux-form";
import style from '../style.module.scss';

export default function SignupForm(props: { authenticityToken: string }) {
  return (
    <div className={style.sampleBox}>
      <div className={style.sampleDescription}>
        <p><strong>Create Your Free Profile</strong></p>
        <p>
          Sign up <strong>now</strong> to get over 100 lessons and practice questions for free.
          Start improving your score today!
        </p>
      </div>
      <div className={style.formContainer}>
        <UserForm onSubmit={onSubmitSignupForm}
                  initialValues={{authenticityToken: props.authenticityToken}}
                  buttonText={'Sign up'}
        />
      </div>
    </div>
  )
}

function onSubmitSignupForm(values, dispatch) {
  return fetch(paths.api.subscriptionsBasic(), {
    body: JSON.stringify(values), method: 'POST'
  }).then(response => {
    window.location.assign(paths.welcome('false'));
  }).catch(response => {
    throw new SubmissionError(response.errors);
  })
}
